var CountDown=new Class({
	initialize: function(el, seconds){
		this.el=el;
		this.seconds=seconds;
		this.timer=setInterval(function(){
			this.el.set('text', this.format(this.seconds--));
		}.bind(this), 1000);
	},

	format: function(seconds){
		var s=seconds%60; seconds=(seconds-s)/60;
		var m=seconds%60; seconds=(seconds-m)/60;
		var h=seconds%24; seconds=(seconds-h)/24;
		var d=seconds;

		var text=d>0 ? d+" days " : "";
		text+=(h>9 ? h : "0"+h)+":"+(m>9 ? m : "0"+m)+":"+(s>9 ? s : "0"+s);
		return text;
	}
});
